/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
import {
  DownloadOutlined,
  FileTextOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import {
  Button,
  Col,
  DatePicker,
  Dropdown,
  Menu,
  Row,
  Spin,
  Table,
} from 'antd';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Cell,
  Legend,
  Pie,
  PieChart as RPieChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import { getStatisticsApi } from '../../api/customerApi';
import {
  NAMESPACE,
  NOTIFIES,
  DECODED_ACCESS_TOKEN,
} from '../../constants/system.keys';
import { formatBytes } from '../../untils/network';
import BandWidthChart from './BandwidthChart';
import { RankChart } from './RankChart';
import './index.scss';
import { REPORT_TYPE } from '../../constants';
import * as ACTIONS from '../../redux/actions';
import storageService from '../../services/storage.service';
import { useSelector } from 'react-redux';
import { toPng } from 'html-to-image';

const { RangePicker } = DatePicker;

function compareEvents(a, b) {
  if (a.events < b.events) {
    return 1;
  }
  if (a.events > b.events) {
    return -1;
  }
  return 0;
}

function compareStorage(a, b) {
  if (a.dayStorage < b.dayStorage) {
    return 1;
  }
  if (a.dayStorage > b.dayStorage) {
    return -1;
  }
  return 0;
}

function compareDate(a, b) {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
}

const CustomCameraTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    console.log('Payload: ', payload);
    return (
      <div
        style={{
          backgroundColor: '#000',
          padding: '10px',
        }}
      >
        <span style={{ color: `${payload[0].payload.color}` }}>{`${
          payload[0].name
        }: ${((payload[0].value / payload[0].payload.total) * 100).toFixed(
          2,
        )}%`}</span>
      </div>
    );
  }

  return null;
};

const renderLegend = (props) => {
  const { payload } = props;
  return (
    <ul className="legend-wrapper">
      {payload.map((entry, index) => (
        <li
          className="item-legend"
          style={{ color: entry.color }}
          key={`item-${index}`}
        >
          <span className="bullet" style={{ background: entry.color }}></span>
          {`${entry.value} - ${(entry.payload?.percent * 100).toFixed(2)}%`}
        </li>
      ))}
    </ul>
  );
};

const ReportPage = () => {
  const { t } = useTranslation();
  const [data, setData] = useState();
  const [cameraData, setCameraData] = useState();
  const [gatewayData, setGatewayData] = useState();
  const [topCameraData, setTopCameraData] = useState();
  const [topGatewayData, setTopGatewayData] = useState();
  const [networkInData, setNetworkInData] = useState([]);
  const [networkOutData, setNetWorkOutData] = useState([]);
  const [storageCamera, setStorageCamera] = useState([]);
  const [isLoadingExportAccountCamera, setIsLoadingExportAccountCamera] =
    useState(false);
  const [isLoadingExportStorageCamera, setIsLoadingExportStorageCamera] =
    useState(false);
  const [isLoadingExportGatewayCamera, setIsLoadingExportGatewayCamera] =
    useState(false);
  const [
    isLoadingExportGatewayCameraInfo,
    setIsLoadingExportGatewayCameraInfo,
  ] = useState(false);
  const { namespace } = useSelector((state) => state);

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    if (percent === 0) {
      return null;
    }

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize="smaller"
      >
        {`${(percent * 100).toFixed(2)}%`}
      </text>
    );
  };

  const [dateRanger, setDateRanger] = useState([
    moment()
      .subtract({ month: 1 })
      .set({ hour: 0, minute: 0, second: 0 })
      .valueOf(),
    moment().set({ hour: 23, minute: 59, second: 59 }).valueOf(),
  ]);

  const column = [
    {
      title: 'Số lượng ngày lưu',
      dataIndex: 'dayStorage',
      key: 'dayStorage',
    },
    {
      title: 'Số lượng camera',
      dataIndex: 'numberCamera',
      key: 'numberCamera',
    },
  ];

  const [loading, setLoading] = useState(false);

  const changeDateRanger = (delta) => {
    const dataFromTime = Math.floor(
      moment()
        .subtract({ days: delta })
        .set({ hour: 0, minute: 0, second: 0 })
        .valueOf(),
    );
    const dataToTime = Math.floor(
      moment().set({ hour: 23, minute: 59, second: 59 }).valueOf(),
    );

    setDateRanger([dataFromTime, dataToTime]);
  };

  const getDataStatistics = async (startTime, endTime) => {
    setLoading(true);
    const token = storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);
    const dataQuery = {
      fromTime: startTime,
      toTime: endTime,
      customerNamespace: namespace,
    };
    const dataRes = await getStatisticsApi(token, { namespace }, dataQuery);
    if (dataRes?.data?.statistic) {
      setData(dataRes?.data?.statistic ?? {});
    }
    setLoading(false);
  };

  useEffect(() => {
    if (data) {
      if (data.cameraDisconnectionSession) {
        const d = [
          {
            name: 'Hoạt động',
            value:
              (data?.cameraDisconnectionSession?.totalCameraTime || 0) -
              (data?.cameraDisconnectionSession?.cameraDisconnectionTime || 0) -
              (data?.cameraDisconnectionSession
                ?.cameraDisconnectionByBoxHangSeconds || 0) -
              (data?.cameraDisconnectionSession
                ?.cameraDisconnectionByBoxBrokenSeconds || 0) -
              (data?.cameraDisconnectionSession
                ?.cameraDisconnectionByOutageSeconds || 0) -
              (data?.cameraDisconnectionSession
                ?.cameraDisconnectionBySwitchErrorSeconds || 0) -
              (data?.cameraDisconnectionSession
                ?.cameraDisconnectionByCameraErrorSeconds || 0) -
              (data?.cameraDisconnectionSession
                ?.cameraDisconnectionByChannelErrorSeconds || 0) -
              (data?.cameraDisconnectionSession
                ?.cameraDisconnectionBySystemErrorSeconds || 0),
            color: '#0e9347',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
          {
            name: 'Lỗi khác',
            value:
              data?.cameraDisconnectionSession?.cameraDisconnectionTime || 0,
            color: '#f95959',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
          {
            name: 'Treo box',
            value:
              data?.cameraDisconnectionByBoxHangSeconds
                ?.cameraDisconnectionByBoxHangSeconds || 0,
            color: '#9f1e49',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
          {
            name: 'Hỏng box',
            value:
              data?.cameraDisconnectionByBoxBrokenSeconds
                ?.cameraDisconnectionByBoxBrokenSeconds || 0,
            color: '#DC6B19',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
          {
            name: 'Mất điện',
            value:
              data?.cameraDisconnectionByOutageSeconds
                ?.cameraDisconnectionByOutageSeconds || 0,
            color: '#A34343',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
          {
            name: 'Lỗi switch',
            value:
              data?.cameraDisconnectionBySwitchErrorSeconds
                ?.cameraDisconnectionBySwitchErrorSeconds || 0,
            color: '#FFC94A',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
          {
            name: 'Lỗi camera',
            value:
              data?.cameraDisconnectionByCameraErrorSeconds
                ?.cameraDisconnectionByCameraErrorSeconds || 0,
            color: '#D20062',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
          {
            name: 'Lỗi kênh truyền',
            value:
              data?.cameraDisconnectionByChannelErrorSeconds
                ?.cameraDisconnectionByChannelErrorSeconds || 0,
            color: '#cd4545',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
          {
            name: 'Lỗi hệ thống',
            value:
              data?.cameraDisconnectionBySystemErrorSeconds
                ?.cameraDisconnectionBySystemErrorSeconds || 0,
            color: '#FF9800',
            total: data?.cameraDisconnectionSession?.totalCameraTime || 0,
          },
        ];

        setCameraData(d);
      }

      if (data.gatewayDisconnectionSession) {
        const gD = [
          {
            name: 'Hoạt động',
            value:
              (data?.gatewayDisconnectionSession?.totalGatewayTime || 0) -
              (data?.gatewayDisconnectionSession?.gatewayDisconnectionTime ||
                0),
            color: '#0e9347',
            total: data?.gatewayDisconnectionSession?.totalGatewayTime || 0,
          },
          {
            name: 'Không hoạt động',
            value:
              data?.gatewayDisconnectionSession?.gatewayDisconnectionTime || 0,
            color: '#f95959',
            total: data?.gatewayDisconnectionSession?.totalGatewayTime || 0,
          },
        ];
        setGatewayData(gD);
      }

      if (data.cameraDisconnectionEvent) {
        setTopCameraData(
          data.cameraDisconnectionEvent.sort(compareEvents).map((item) => {
            return {
              name: `${item.name} (${item.serial})`,
              value: item.events,
            };
          }),
        );
      }

      if (data.gatewayDisconnectionEvent) {
        setTopGatewayData(
          data.gatewayDisconnectionEvent.sort(compareEvents).map((item) => {
            return {
              name: `${item.name} (${item.serial})`,
              value: item.events,
            };
          }),
        );
      }

      if (data.gatewayNetworkOut) {
        setNetWorkOutData(
          data.gatewayNetworkOut
            .map((item) => {
              const minValue = formatBytes(item.networkInMin, 'Mbps');
              const maxValue = formatBytes(item.networkInMax, 'Mbps');

              return {
                name: item.recordDate,
                min: minValue.value,
                max: maxValue.value,
              };
            })
            .sort(compareDate),
        );
      }

      if (data.gatewayNetworkIn) {
        setNetworkInData(
          data.gatewayNetworkIn
            .map((item) => {
              const minValue = formatBytes(item.networkInMin, 'Mbps');
              const maxValue = formatBytes(item.networkInMax, 'Mbps');
              return {
                name: item.recordDate,
                min: minValue.value,
                max: maxValue.value,
              };
            })
            .sort(compareDate),
        );
      }

      if (data.cameraStatisticStorage) {
        setStorageCamera(data.cameraStatisticStorage.sort(compareStorage));
      }
    }
  }, [data]);

  const handleDateRangerChange = (values) => {
    if (values?.length === 2) {
      const FromDate =
        values.length > 0
          ? values[0].set({ hour: 0, minute: 0, second: 0 })
          : '';
      const ToDate =
        values.length > 0
          ? values[1].set({ hour: 23, minute: 59, second: 59 })
          : '';
      const dataArr = [FromDate, ToDate];
      setDateRanger(dataArr.map((item) => Math.floor(moment(item).valueOf())));
    } else {
      setDateRanger([]);
    }
  };

  const handleExportPdf = async () => {
    const element = document.getElementById('data-report');
    if (!element) return;

    const overlay = document.createElement('div');
    overlay.style.cssText = `
    position: fixed;
    top: 0; left: 0;
    width: 100vw; height: 100vh;
    background: #1f1f1f;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 16px;
    font-family: sans-serif;
  `;
    overlay.textContent = 'Đang xuất PDF...';
    // document.body.appendChild(overlay);

    const prevBg = element.style.backgroundColor;
    const prevColor = element.style.color;
    element.style.backgroundColor = '#000';

    await new Promise((r) => setTimeout(r, 300));

    const allTexts = element.querySelectorAll(
      'text, tspan, .recharts-text, div',
    );
    const textColors = [];
    allTexts.forEach((el) => {
      textColors.push(el.getAttribute('fill'));
      const fill = el.getAttribute('fill');
      if (!fill || fill === '#000000' || fill === 'black' || fill === '#000') {
        el.setAttribute('fill', '#fff');
      }
    });

    const restoreAll = () => {
      element.style.backgroundColor = prevBg;
      element.style.color = prevColor;
      allTexts.forEach((el, i) => {
        if (textColors[i]) el.setAttribute('fill', textColors[i]);
        else el.removeAttribute('fill');
      });
    };

    try {
      const dataUrl = await toPng(element, {
        backgroundColor: '#ffffff',
        pixelRatio: 2,
        filter: (node) => node.tagName !== 'IFRAME',
      });

      restoreAll();

      const img = new Image();
      img.src = dataUrl;
      await new Promise((r) => (img.onload = r));

      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
      });
      const pageW = doc.internal.pageSize.getWidth();
      const pageH = doc.internal.pageSize.getHeight();
      const margin = 5;
      const contentW = pageW - margin * 2;
      const headerH = 28;

      doc.setFillColor(204, 204, 204);
      doc.rect(0, 0, pageW, headerH, 'F');
      doc.setFontSize(14);
      doc.setFont(undefined, 'bold');
      doc.setTextColor(0, 0, 0);
      doc.text('Report Cloud Camera', pageW / 2, 12, { align: 'center' });
      doc.setFontSize(11);
      doc.setFont(undefined, 'italic');
      doc.text(
        `Time: ${moment(dateRanger[0]).format('YYYY-MM-DD')} - ${moment(dateRanger[1]).format('YYYY-MM-DD')}`,
        pageW / 2,
        22,
        { align: 'center' },
      );

      const imgHeightMm = (img.height / img.width) * contentW;
      const firstPageAvailH = pageH - headerH - margin - 2;
      const otherPageAvailH = pageH - margin * 2;

      if (imgHeightMm <= firstPageAvailH) {
        doc.addImage(
          dataUrl,
          'PNG',
          margin,
          headerH + 2,
          contentW,
          imgHeightMm,
        );
      } else {
        const pxPerMm = img.width / contentW;
        const offscreen = document.createElement('canvas');
        const ctx = offscreen.getContext('2d');
        offscreen.width = img.width;
        let srcY = 0;
        let pageIndex = 0;

        while (srcY < img.height) {
          const availH = pageIndex === 0 ? firstPageAvailH : otherPageAvailH;
          const slicePx = Math.floor(availH * pxPerMm);
          const actualPx = Math.min(slicePx, img.height - srcY);

          offscreen.height = actualPx;
          ctx.clearRect(0, 0, offscreen.width, actualPx);
          ctx.drawImage(
            img,
            0,
            srcY,
            img.width,
            actualPx,
            0,
            0,
            img.width,
            actualPx,
          );

          const sliceUrl = offscreen.toDataURL('image/png');
          const sliceHmm = actualPx / pxPerMm;
          const destY = pageIndex === 0 ? headerH + 2 : margin;

          if (pageIndex > 0) doc.addPage();
          doc.addImage(sliceUrl, 'PNG', margin, destY, contentW, sliceHmm);

          srcY += actualPx;
          pageIndex++;
        }
      }

      doc.save('report.pdf');
    } catch (err) {
      console.error('Export PDF error:', err);
      restoreAll();
    } finally {
      // Xóa overlay sau khi xong
      if (overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    }
  };

  const downloadFile = async (token, selectedReport, namespace) => {
    try {
      const response = await fetch(
        'https://resource-api.beex.vn:8050/commands',
        {
          method: 'POST',
          headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: token,
            'Content-Type': 'application/json',
            namespace,
          },
          body: JSON.stringify({
            command: selectedReport.command,
            params: `{"customerNamespace":${namespace},"isDownload":1}`,
          }),
        },
      );

      if (!response.ok) {
        throw new Error('Failed to download file');
      }

      // Đọc phản hồi dưới dạng Blob
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Tạo thẻ a để tải xuống
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `${selectedReport.command}_${namespace}.xlsx`,
      ); // Đặt tên cho tệp
      document.body.appendChild(link);
      link.click();

      // Dọn dẹp
      link.remove();
      window.URL.revokeObjectURL(url);
      selectedReport.setLoading(false);
    } catch (error) {
      selectedReport.setLoading(false);
      ACTIONS.openMessage(NOTIFIES.WARNING, 'Error when exporting file');
      console.error('Error downloading file:', error);
    }
  };
  const handleDownloadReportAccountCamera = async (typeReport) => {
    const token = storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);

    const reportMapping = {
      [REPORT_TYPE.REPORT_ACCOUNT]: {
        command: 'report_account_camera',
        setLoading: setIsLoadingExportAccountCamera,
      },
      [REPORT_TYPE.REPORT_STORAGE]: {
        command: 'report_camera_storage',
        setLoading: setIsLoadingExportStorageCamera,
      },
      [REPORT_TYPE.REPORT_GATEWAY]: {
        command: 'report_camera_gateway',
        setLoading: setIsLoadingExportGatewayCamera,
      },
      [REPORT_TYPE.REPORT_GATEWAY_INFO]: {
        command: 'report_gateway_info',
        setLoading: setIsLoadingExportGatewayCameraInfo,
      },
    };

    const selectedReport = reportMapping[typeReport];
    if (!selectedReport) return;

    selectedReport.setLoading(true);

    try {
      downloadFile(token, selectedReport, namespace);
    } catch (error) {
      ACTIONS.openMessage(NOTIFIES.WARNING, 'Error when exporting file');
      selectedReport.setLoading(false);
    }
  };
  useEffect(() => {
    if (dateRanger) {
      getDataStatistics(dateRanger[0], dateRanger[1]);
    }
  }, [dateRanger]);

  return (
    <div className="report-management-component">
      <Row>
        <Col className="pinned-report-component">
          <Row style={{ marginBottom: 10, padding: '0px 20px' }}>
            <Col span={12} className="input_date_picker">
              <Button onClick={() => changeDateRanger(7)}>
                The last 7 days
              </Button>
              <Button onClick={() => changeDateRanger(30)}>
                The last month
              </Button>
              <RangePicker
                defaultValue={[
                  moment()
                    .subtract({ month: 1 })
                    .set({ hour: 0, minute: 0, second: 0 }),
                  moment().set({ hour: 23, minute: 59, second: 59 }),
                ]}
                value={[moment(dateRanger[0]), moment(dateRanger[1])]}
                onChange={handleDateRangerChange}
              />
            </Col>
            <Col span={12}>
              <Row justify="end" gutter={[8, 8]}>
                <Col>
                  <div className="edit-button" title="Report">
                    <Dropdown
                      trigger={['click']}
                      placement="bottomRight"
                      overlay={
                        <Menu>
                          <Menu.Item
                            key="0"
                            onClick={() =>
                              handleDownloadReportAccountCamera(
                                REPORT_TYPE.REPORT_ACCOUNT,
                              )
                            }
                            disabled={isLoadingExportAccountCamera}
                          >
                            {isLoadingExportAccountCamera ? (
                              <span>
                                <LoadingOutlined />
                              </span>
                            ) : (
                              <span>
                                <DownloadOutlined />
                              </span>
                            )}
                            <span>Report account camera</span>
                          </Menu.Item>
                          <Menu.Item
                            key="1"
                            onClick={() =>
                              handleDownloadReportAccountCamera(
                                REPORT_TYPE.REPORT_STORAGE,
                              )
                            }
                            disabled={isLoadingExportStorageCamera}
                          >
                            {isLoadingExportStorageCamera ? (
                              <span>
                                <LoadingOutlined />
                              </span>
                            ) : (
                              <span>
                                <DownloadOutlined />
                              </span>
                            )}
                            <span>Report storage camera</span>
                          </Menu.Item>
                          <Menu.Item
                            key="2"
                            onClick={() =>
                              handleDownloadReportAccountCamera(
                                REPORT_TYPE.REPORT_GATEWAY,
                              )
                            }
                            disabled={isLoadingExportGatewayCamera}
                          >
                            {isLoadingExportGatewayCamera ? (
                              <span>
                                <LoadingOutlined />
                              </span>
                            ) : (
                              <span>
                                <DownloadOutlined />
                              </span>
                            )}
                            <span>Report camera/gateway information</span>
                          </Menu.Item>
                          <Menu.Item
                            key="3"
                            onClick={() =>
                              handleDownloadReportAccountCamera(
                                REPORT_TYPE.REPORT_GATEWAY_INFO,
                              )
                            }
                            disabled={isLoadingExportGatewayCameraInfo}
                          >
                            {isLoadingExportGatewayCameraInfo ? (
                              <span>
                                <LoadingOutlined />
                              </span>
                            ) : (
                              <span>
                                <DownloadOutlined />
                              </span>
                            )}
                            <span>Report gateway information</span>
                          </Menu.Item>
                        </Menu>
                      }
                    >
                      <Button icon={<FileTextOutlined />}>Report</Button>
                    </Dropdown>
                  </div>
                </Col>

                <Col className="export-button">
                  <Button onClick={handleExportPdf}>Export</Button>
                </Col>
              </Row>
            </Col>
          </Row>
          {loading ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <div
              id="data-report"
              style={{ padding: '0px 20px', backgroundColor: '#000' }}
            >
              {(data?.cameraDisconnectionSession ||
                data?.gatewayDisconnectionSession) && (
                <div>
                  <div className="section-title">THỜI GIAN HOẠT ĐỘNG</div>
                  <Row gutter={8}>
                    <Col span={12}>
                      <div className="chart-item content-center">
                        <div className="chart-title">Camera</div>
                        <Row style={{ width: '100%' }}>
                          <Col span={6}>
                            <div className="extra-info">
                              <div>Camera Quantity</div>
                              <div className="total-device">
                                {data?.cameraDisconnectionSession
                                  ?.totalCamera || 0}
                              </div>
                            </div>
                          </Col>
                          <Col span={18}>
                            <ResponsiveContainer width={500} height={300}>
                              <RPieChart width={500} height={300}>
                                <Pie
                                  dataKey="value"
                                  isAnimationActive={false}
                                  data={cameraData}
                                  cx="50%"
                                  cy="50%"
                                  outerRadius={90}
                                  innerRadius={40}
                                  fill="#8884d8"
                                  labelLine={false}
                                  label={renderCustomizedLabel}
                                >
                                  {cameraData.map((entry, index) => (
                                    <Cell
                                      key={`cell-${index}`}
                                      fill={cameraData[index].color}
                                      stroke="none"
                                    />
                                  ))}
                                </Pie>

                                <Tooltip content={<CustomCameraTooltip />} />
                                <Legend
                                  layout="vertical"
                                  align="left"
                                  verticalAlign="middle"
                                  content={renderLegend}
                                />
                              </RPieChart>
                            </ResponsiveContainer>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="chart-item content-center">
                        <div className="chart-title">Gateway</div>
                        <Row style={{ width: '100%' }}>
                          <Col span={6}>
                            <div className="extra-info">
                              <div>Gateway Quantity</div>
                              <div className="total-device">
                                {data?.gatewayDisconnectionSession
                                  ?.totalGateway || 0}
                              </div>
                            </div>
                          </Col>
                          <Col span={18}>
                            <ResponsiveContainer width={700} height={300}>
                              <RPieChart width={700} height={300}>
                                <Pie
                                  dataKey="value"
                                  isAnimationActive={false}
                                  data={gatewayData}
                                  cx="50%"
                                  cy="50%"
                                  outerRadius={90}
                                  innerRadius={40}
                                  fill="#8884d8"
                                  labelLine={false}
                                  label={renderCustomizedLabel}
                                >
                                  {gatewayData?.map((entry, index) => (
                                    <Cell
                                      key={`cell-${index}`}
                                      fill={gatewayData[index].color}
                                      stroke="none"
                                    />
                                  ))}
                                </Pie>

                                <Tooltip content={<CustomCameraTooltip />} />
                                <Legend
                                  align="center"
                                  verticalAlign="middle"
                                  content={renderLegend}
                                />
                              </RPieChart>
                            </ResponsiveContainer>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}

              {(data?.cameraDisconnectionEvent ||
                data?.gatewayDisconnectionEvent) && (
                <div>
                  <div className="section-title">
                    THỐNG KÊ THEO SỐ LƯỢNG SỰ CỐ
                  </div>
                  <Row gutter={8} style={{ marginTop: 10 }}>
                    <Col span={12} style={{ alignSelf: 'stretch' }}>
                      <div
                        className="content-center chart-item"
                        style={{ height: '100%' }}
                      >
                        <div className="chart-title">
                          Top cameras disconnected
                        </div>
                        <RankChart color="#FFC94A" data={topCameraData} />
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="content-center chart-item">
                        <div className="chart-title">
                          Top gateways disconnected
                        </div>
                        <RankChart color="#FFC94A" data={topGatewayData} />
                      </div>
                    </Col>
                  </Row>
                </div>
              )}

              {data?.cameraStatisticStorage && (
                <div>
                  <div className="section-title">
                    THỐNG KÊ SỐ LƯỢNG LƯU TRỮ CAMERA
                  </div>
                  <Row>
                    <Col span={24}>
                      <Table
                        size="small"
                        columns={column}
                        pagination={{
                          total: storageCamera.length,
                          position: ['bottomRight'],
                          pageSizeOptions: [10, 20, 50, 100, 200, 400],
                        }}
                        dataSource={storageCamera}
                      />
                    </Col>
                  </Row>
                </div>
              )}

              {(data?.gatewayNetworkIn || data?.gatewayNetworkOut) && (
                <div>
                  <div className="section-title">
                    THỐNG KÊ BĂNG THÔNG GATEWAY
                  </div>
                  <Row gutter={8} style={{ marginTop: 10 }}>
                    <Col span={12}>
                      <div className="content-center chart-item">
                        <div className="chart-title">Bandwidth network in</div>
                        <BandWidthChart
                          height={400}
                          data={networkInData}
                          yLabel="Mbps"
                        />
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="content-center chart-item">
                        <div className="chart-title">Bandwidth network out</div>
                        <BandWidthChart
                          height={400}
                          data={networkOutData}
                          yLabel="Mbps"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ReportPage;
